(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aviso-100ml"] && !Shopify.designMode) return;
  try {
    (function () {
    function norm(s) {
      return String(s || '').toLowerCase().replace(/\s+/g, '');
    }

    function scopeOf(el) {
      return el.closest('product-info, .product-information, .product, main, form') || document;
    }

    function currentId(el) {
      var scope = scopeOf(el);
      var input = scope.querySelector('form[action*="/cart/add"] [name="id"]') ||
        document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) return String(input.value);
      var fromUrl = new URLSearchParams(window.location.search).get('variant');
      return fromUrl ? String(fromUrl) : '';
    }

    function sync(el) {
      var id = currentId(el);
      if (!id) return;
      el.hidden = id === el.dataset.targetId;
    }

    function switchTo(el) {
      var want = norm(el.dataset.targetValue);
      var scope = scopeOf(el);
      var inputs = Array.prototype.slice.call(
        scope.querySelectorAll('input[type="radio"], option')
      );
      var match = inputs.find(function (node) {
        var v = norm(node.value);
        return v === want || v.indexOf(want) !== -1;
      });

      if (match && match.tagName === 'OPTION') {
        var select = match.closest('select');
        select.value = match.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (match) {
        var label = match.id ? scope.querySelector('label[for="' + match.id + '"]') : null;
        if (label) label.click(); else match.click();
        if (!match.checked) {
          match.checked = true;
          match.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', el.dataset.targetId);
        window.location.href = url.toString();
        return;
      }
      window.setTimeout(function () { sync(el); }, 300);
    }

    function setup() {
      document.querySelectorAll('[data-t100]').forEach(function (el) {
        if (el.dataset.t100Ready) { sync(el); return; }
        el.dataset.t100Ready = '1';
        el.querySelector('[data-t100-switch]').addEventListener('click', function () { switchTo(el); });
        sync(el);
      });
    }

    var later = function () {
      window.setTimeout(function () {
        document.querySelectorAll('[data-t100]').forEach(sync);
      }, 120);
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
    else setup();
    document.addEventListener('change', later, true);
    document.addEventListener('click', later, true);
    ['variant:update', 'variant:change', 'variant:selected'].forEach(function (name) {
      document.addEventListener(name, later);
    });
    window.addEventListener('popstate', later);
    document.addEventListener('shopify:section:load', setup);
    document.addEventListener('shopify:block:select', setup);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["boton-arma-kit"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(el) {
      if (el.__tpbk) return;
      el.__tpbk = true;
      var btn = el.querySelector('.tpbk__btn');
      var err = el.querySelector('.tpbk__error');
      var ok = (el.dataset.ok || '').split(',').filter(Boolean);

      function varianteActual() {
        var scope = el.closest('.shopify-section') || document;
        var form = scope.querySelector('form[action*="/cart/add"]:not([id*="installment" i])');
        var idInput = form && form.querySelector('[name="id"]');
        return String((idInput && idInput.value) || new URLSearchParams(location.search).get('variant') || el.dataset.variante);
      }
      function revisar() {
        if (!el.dataset.filtrar) return;
        el.hidden = ok.indexOf(varianteActual()) === -1;
      }
      function revisarLuego() { setTimeout(revisar, 60); setTimeout(revisar, 400); }
      document.addEventListener('variant:update', revisarLuego);
      document.addEventListener('change', revisarLuego);
      window.addEventListener('popstate', revisarLuego);
      revisar();

      btn.addEventListener('click', function () {
        var scope = el.closest('.shopify-section') || document;
        var form = scope.querySelector('form[action*="/cart/add"]:not([id*="installment" i])');
        var idInput = form && form.querySelector('[name="id"]');
        var qtyInput = (form && form.querySelector('[name="quantity"]')) || scope.querySelector('input[name="quantity"]');
        var variante = Number((idInput && idInput.value) || el.dataset.variante);
        var cantidad = Math.max(1, Number(qtyInput && qtyInput.value) || 1);

        btn.setAttribute('aria-busy', 'true'); err.hidden = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variante, quantity: cantidad }] })
        })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'No se pudo agregar'); return j; }); })
          .then(function () {
            var url = el.dataset.destino;
            if (el.dataset.nivel) url += (url.indexOf('?') === -1 ? '?' : '&') + 'nivel=' + el.dataset.nivel;
            location.href = url;
          })
          .catch(function (e) { err.textContent = e.message; err.hidden = false; btn.removeAttribute('aria-busy'); });
      });
    }
    function initAll() { document.querySelectorAll('[data-tpbk]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["envio-garantia"] && !Shopify.designMode) return;
  try {
    (function () {
    var DAYS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

    function localNow(tz) {
      try {
        return new Date(new Date().toLocaleString('en-US', { timeZone: tz || 'America/Mexico_City' }));
      } catch (e) {
        return new Date();
      }
    }

    function isWorkday(d, weekends) {
      var day = d.getDay();
      return weekends || (day !== 0 && day !== 6);
    }

    function addWorkdays(start, n, weekends) {
      var d = new Date(start.getTime());
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        if (isWorkday(d, weekends)) added += 1;
      }
      return d;
    }

    function fmt(d) {
      return '<strong>' + DAYS[d.getDay()] + ' ' + d.getDate() + '</strong>';
    }

    function fmtFull(d) {
      return '<strong>' + DAYS[d.getDay()] + ' ' + d.getDate() + ' de ' + MONTHS[d.getMonth()] + '</strong>';
    }

    function render(el) {
      var target = el.querySelector('[data-teg-ship]');
      if (!target) return;
      var cutoff = Number(el.dataset.cutoff);
      var min = Number(el.dataset.min);
      var max = Math.max(min, Number(el.dataset.max));
      var weekends = el.dataset.weekends === 'true';
      var now = localNow(el.dataset.tz);

      var ship = new Date(now.getTime());
      var shipsToday = isWorkday(now, weekends) && now.getHours() < cutoff;
      if (!shipsToday) {
        do { ship.setDate(ship.getDate() + 1); } while (!isWorkday(ship, weekends));
      }

      var from = addWorkdays(ship, min, weekends);
      var to = addWorkdays(ship, max, weekends);

      var first = shipsToday
        ? el.dataset.today
        : (el.dataset.other || '').replace('[dia]', DAYS[ship.getDay()]);
      var range = min === max
        ? fmtFull(to)
        : (from.getMonth() === to.getMonth() ? fmt(from) : fmtFull(from)) + ' y el ' + fmtFull(to);
      var arrives = (el.dataset.arrives || '').replace('[fechas]', range);

      target.innerHTML = '<span class="teg__dot" aria-hidden="true"></span>' + first + ' ' + arrives;
    }

    function run() {
      document.querySelectorAll('[data-teg]').forEach(render);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:block:select', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ficha-olfativa"] && !Shopify.designMode) return;
  try {
    (function () {
    function setup(root) {
      root.querySelectorAll('[data-tfo-notes]').forEach(function (d) {
        if (d.dataset.tfoReady) return;
        d.dataset.tfoReady = '1';
        var text = d.querySelector('.tfo__notes-text');
        if (!text) return;
        var check = function () {
          if (d.open) return;
          var clipped = text.scrollHeight > text.clientHeight + 1;
          d.classList.toggle('is-short', !clipped);
        };
        d.addEventListener('click', function (e) {
          if (d.classList.contains('is-short')) e.preventDefault();
        });
        check();
        window.addEventListener('resize', check);
      });
    }
    var run = function () { setup(document); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:block:select', run);
  })();
  } catch(e) { console.error(e); }
})();

})();
